import "../components/About.css"


function About() {
  return (
    <div className="about">
  <h3 >Graze is an application where users can post about their favorite dishes at restaurants.</h3>
    </div>
  )
}

export default About 